import React from "react";
import { toPrettyDateStr } from "../../prettyDate";
import "./data-available-since.css";

/**
 * How far back the lightning history goes for a windfarm - the start of the period the
 * extraction has ever covered. Asking for a range that begins before it returns nothing,
 * with no way to tell that apart from a quiet period, so it is worth stating up front.
 *
 * Takes the raw `earliest_data` off a windfarm and renders nothing when it is missing, so
 * callers can drop it in without guarding first.
 */
export default function DataAvailableSince({ earliestData, className = "" }) {
  if (!earliestData) return null;

  const date = new Date(earliestData);
  if (Number.isNaN(date.getTime())) return null;

  return (
    <span className={`data-available-since ${className}`.trim()}>
      Data available since {toPrettyDateStr(date)}
    </span>
  );
}
